import React, {useEffect, useRef} from 'react';
import ItemSelectPointFromAndToMutateSingleVoyage from "./pointItem/ItemSelectPointFromAndToMutateSingleVoyage";
import Stack from '@mui/material/Stack';
import {sx} from './sx'
import Typography from '@mui/material/Typography';
import {useTranslation} from 'react-i18next';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import CloseIcon from '@mui/icons-material/Close';
import {DomEvent} from 'leaflet';
import {IWayPointCreationWithCorrectionsSingleVoyage} from "@containers/singleVoyage/types/point";
import {
    OnSelectPointsFromAndToCb
} from "@containers/singleVoyage/mutateVoyage/points/selectPointsFromAndTo/types/events";

interface IProps {
    onSelect: OnSelectPointsFromAndToCb,
    onCancel: () => void,
    points: IWayPointCreationWithCorrectionsSingleVoyage[],
}

const SelectPointFromAndToMutateSingleVoyage = ({
                                                    onSelect,
                                                    onCancel,
                                                    points,
                                                }: IProps) => {

    const ref = useRef<HTMLDivElement>(null);
    const {t} = useTranslation()

    // the panel sits on top of the map: clicks and scrolling inside it must not reach leaflet
    useEffect(() => {
        const element = ref.current;
        if (!element) {
            return
        }
        DomEvent.disableClickPropagation(element)
        DomEvent.disableScrollPropagation(element)
    }, []);

    return (
        <Box
            sx={sx.root}
            ref={ref}
        >
            <Stack
                direction={'row'}
                alignItems={'center'}
                justifyContent={'space-between'}
                gap={1}
                sx={sx.header}
            >
                <Box>
                    <Typography sx={sx.title}>
                        {t('singleVoyage.selectRouteSegment')}
                    </Typography>
                    <Typography sx={sx.hint}>
                        {t('singleVoyage.selectRouteSegmentHint')}
                    </Typography>
                </Box>

                <Tooltip title={t('base.cancel')}>
                    <IconButton
                        size={'small'}
                        onClick={onCancel}
                        sx={sx.close}
                        aria-label={t('base.cancel')}
                    >
                        <CloseIcon fontSize={'small'}/>
                    </IconButton>
                </Tooltip>
            </Stack>

            <Stack sx={sx.list}>
                {points?.slice(0, -1).map((point, index) => (
                    <ItemSelectPointFromAndToMutateSingleVoyage
                        point={point}
                        nextPoint={points[index + 1]}
                        index={index}
                        onSelect={onSelect}
                        key={point.id ?? index}
                    />
                ))}
            </Stack>
        </Box>
    );
};

export default SelectPointFromAndToMutateSingleVoyage;
